import { fetchExternalHoldings } from 'views/Portfolio/components/Details/services/fetchExternalHoldings';
import { ToolExecutionResult } from '../types';
import { formatCurrency } from '../utils/formatters';

export const executeGetExternalHoldings = async (args: Record<string, unknown>): Promise<ToolExecutionResult> => {
  try {
    const limit = (args.limit as number) || 20;
    const response = await fetchExternalHoldings({ limit });

    if (!response.data || response.data.length === 0) {
      return {
        success: true,
        data: {
          message: 'No external holdings found. You do not have any wines stored externally.',
          holdings: [],
          count: 0,
        },
      };
    }

    const holdings = response.data.slice(0, limit).map((holding) => ({
      wineName: holding.wineName || holding.lwin18,
      vintage: holding.vintage,
      region: holding.cultWinesAllocationRegion,
      quantity: holding.qty,
      currentValue: formatCurrency(holding.totalValue || 0),
      costBasis: formatCurrency(holding.totalCost || 0),
      status: holding.status,
      location: holding.location || 'External Storage',
    }));

    // Calculate summary stats
    const totalValue = response.data.reduce((sum, h) => sum + (h.totalValue || 0), 0);
    const totalBottles = response.data.reduce((sum, h) => sum + (h.qty || 0), 0);

    return {
      success: true,
      data: {
        holdings,
        count: response.data.length,
        summary: {
          totalValue: formatCurrency(totalValue),
          totalBottles,
          uniqueWines: response.data.length,
        },
      },
    };
  } catch (error) {
    return {
      success: false,
      error: `Failed to fetch external holdings: ${(error as Error).message}`,
    };
  }
};
